import React from "react";

import { Stack, Box } from "@mui/material";
import { Typography } from "components";

interface LoadingOverlayProps {
  loading?: boolean;
  label?: string;
  value?: number;
  children: React.ReactNode;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  loading = false,
  label,
  value,
  children,
}) => {
  return (
    <Stack position="relative" borderRadius="12px" width="100%">
      {label && (
        <Stack mb="12px">
          <Typography type="TextLG" fontWeight={600}>
            {label}
          </Typography>
        </Stack>
      )}
      {loading && (
        <Stack
          position="absolute"
          top="20px"
          left={0}
          width="100%"
          height="100%"
          zIndex={200}
          justifyContent="center"
          alignItems="center"
          borderRadius="12px"
          bgcolor="rgba(249, 250, 251, 0.5)"
        >
          <Box className="dotLoading" />
          {!!value && (
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="caption"
                fontWeight={600}
                color="text.secondary"
              >{`${Math.round(value)}%`}</Typography>
            </Box>
          )}
        </Stack>
      )}
      {children}
    </Stack>
  );
};

export default LoadingOverlay;
